/**
 * Progressive image loading for non-active slideshow slides.
 * Extends Symmetry's existing <slide-show> element without replacing slideshow.js.
 */
(() => {
  const SlideShow = customElements.get('slide-show');
  if (!SlideShow || SlideShow.prototype.deferredImagesEnabled) return;

  const proto = SlideShow.prototype;
  proto.deferredImagesEnabled = true;

  proto.loadDeferredSlideImages = function loadDeferredSlideImages(slideIndex) {
    const slides = this.slides || this.querySelectorAll('.slideshow__slide');
    const slide = slides[slideIndex];
    if (!slide) return;

    // Restore <source> first so <picture> selects the correct responsive image.
    slide.querySelectorAll('source[data-manual-srcset]').forEach((source) => {
      source.srcset = source.dataset.manualSrcset;
      source.removeAttribute('data-manual-srcset');
    });

    if (window.theme && typeof window.theme.manuallyLoadImages === 'function') {
      window.theme.manuallyLoadImages(slide);
    } else {
      slide.querySelectorAll('img[data-manual-src]').forEach((image) => {
        image.src = image.dataset.manualSrc;
        image.removeAttribute('data-manual-src');

        if (image.dataset.manualSrcset) {
          image.srcset = image.dataset.manualSrcset;
          image.removeAttribute('data-manual-srcset');
        }
      });
    }
  };

  const originalSetActiveSlide = proto.setActiveSlide;
  proto.setActiveSlide = function setActiveSlideWithDeferredImages(slideIndex, slideDirection) {
    this.loadDeferredSlideImages(slideIndex);
    return originalSetActiveSlide.call(this, slideIndex, slideDirection);
  };

  const getTargetIndex = (slideshow, control) => {
    const slides = slideshow.slides || slideshow.querySelectorAll('.slideshow__slide');
    if (!slides.length) return null;

    if (control.matches('.page-btn')) return Number(control.dataset.index);

    const currentIndex = Number.isInteger(slideshow.currentIndex) ? slideshow.currentIndex : 0;
    if (control.name === 'prev') return currentIndex === 0 ? slides.length - 1 : currentIndex - 1;
    return currentIndex + 1 === slides.length ? 0 : currentIndex + 1;
  };

  const preloadFromControl = (event) => {
    const control = event.target.closest('.page-btn, .slideshow-nav__btn');
    if (!control) return;

    const slideshow = control.closest('slide-show');
    if (!slideshow || typeof slideshow.loadDeferredSlideImages !== 'function') return;

    const targetIndex = getTargetIndex(slideshow, control);
    if (targetIndex !== null) slideshow.loadDeferredSlideImages(targetIndex);
  };

  // Pointer and keyboard intent start the full image request before activation.
  document.addEventListener('pointerover', preloadFromControl, { passive: true });
  document.addEventListener('focusin', preloadFromControl);

  // Start loading adjacent slides on touch before the debounced swipe completes.
  document.addEventListener('touchstart', (event) => {
    const slideshow = event.target.closest('slide-show');
    if (!slideshow || typeof slideshow.loadDeferredSlideImages !== 'function') return;

    const slides = slideshow.slides || slideshow.querySelectorAll('.slideshow__slide');
    if (slides.length < 2) return;

    const currentIndex = Number.isInteger(slideshow.currentIndex) ? slideshow.currentIndex : 0;
    const nextIndex = currentIndex + 1 === slides.length ? 0 : currentIndex + 1;
    const previousIndex = currentIndex === 0 ? slides.length - 1 : currentIndex - 1;
    slideshow.loadDeferredSlideImages(nextIndex);
    slideshow.loadDeferredSlideImages(previousIndex);
  }, { passive: true });
})();
